import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=6fc5059e&scoped=true"
import script from "./PayDialog.vue?vue&type=script&lang=js"
export * from "./PayDialog.vue?vue&type=script&lang=js"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=6fc5059e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5059e",
  null
  
)

export default component.exports